module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StartPage/background-f26ffb2cd403e704e7b0d98c9109ea2c.svg";